import { succeed, field, number } from 'jsonous';

export const pusherEventBreakoutPayload = succeed({}).assign(
  'breakoutEndAt',
  field('breakout_end_at', number)
);
